/* Profession signs share native Shopify prices/cart, with a separate customer flow. */
(() => {
 'use strict';
 const form = document.getElementById('mm-order-form');
 if (!form) return;
 const data = JSON.parse(document.getElementById('mm-catalog-data').textContent);
 data.products.forEach(p=>{p.variants=p.variants.filter(v=>String(v.options[0]).replace(/\s/g,'').replace(/[×✕]/g,'x').toLowerCase()!=='20x30cm');});
 const editorMode=()=>form.querySelector('input[name="designMode"]:checked')?.value==='editor';
 const el = id => document.getElementById('mm-' + id);
 const radios = name => [...form.querySelectorAll('input[name="mm-' + name + '"]')];
 const checked = name => form.querySelector('input[name="mm-' + name + '"]:checked')?.value;
 const choose = (name, value) => radios(name).forEach(input => { input.checked = input.value === value; });
 const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase('tr-TR').replace(/[×✕]/g,'x').replace(/\s+/g,'');
 const money = (cents, fixed=false) => data.currency === 'TRY' ? new Intl.NumberFormat('tr-TR', {minimumFractionDigits:fixed?2:0,maximumFractionDigits:2}).format(cents/100)+' ₺' : new Intl.NumberFormat('tr-TR', {style:'currency',currency:data.currency}).format(cents/100);
 const addButtonIcon = el('add').querySelector('svg')?.cloneNode(true);
 const params = new URLSearchParams(location.search);
 const state = {model:data.initialModel, contact:data.initialContact, variant:null, submitting:false};
 if (data.models.some(model => model.id === params.get('model'))) state.model = params.get('model');
 if (data.contacts.some(contact => contact.id === params.get('iletisim'))) state.contact = params.get('iletisim');
 const initialModel = data.models.find(model => model.id === state.model) || data.models[0];
 choose('profession', initialModel.profession);
 choose('model', initialModel.id);
 choose('contact', state.contact);
 const selectedProduct = () => data.products.find(product => product.model === state.model && product.contact === state.contact);
 const firstProduct = selectedProduct() || data.products[0];
 const uniqueOptions = position => [...new Set((firstProduct?.variants || []).map(variant => variant.options[position]))];
 const deepVariant = selectedProduct()?.variants.find(variant => String(variant.id) === params.get('variant'));
 if (deepVariant) {
  choose('size',deepVariant.options[0]); choose('thickness',deepVariant.options[1]); choose('mount',deepVariant.options[2]);
 } else {
  const initialSize = uniqueOptions(0).find(value => normalize(value) === '30x20cm') || uniqueOptions(0).find(value => normalize(value) === '40x30cm');
  if (initialSize) choose('size',initialSize);
 }
 if (radios('corner').some(input => input.value === params.get('kose'))) choose('corner',params.get('kose'));
 const variantForOptions = (product,size,thickness,mount) => product?.variants.find(variant => normalize(variant.options[0]) === normalize(size) && normalize(variant.options[1]) === normalize(thickness) && normalize(variant.options[2]) === normalize(mount));
 const variantFor = (product,mount) => variantForOptions(product,checked('size'),checked('thickness'),mount);
 const conditional = (field, needed) => {
  const input = el(field === 'second' ? 'second-name' : field);
  el(field + '-field').hidden = !needed; input.disabled = !needed; input.required = needed;
  if (!needed) input.setCustomValidity('');
 };
 function update(updateUrl = true) {
  state.model = checked('model'); state.contact = checked('contact');
  const editing=editorMode();
  const model = data.models.find(item => item.id === state.model);
  const contact = data.contacts.find(item => item.id === state.contact);
  const product = selectedProduct();
  const variant = variantFor(product, checked('mount'));
  state.variant = variant || null;
  const source = model.images[state.contact];
  if (el('main-photo').getAttribute('src') !== source) el('main-photo').src = source;
  el('main-photo').alt = model.label + ' — ' + contact.label + ' — örnek uygulama';
  el('selected-model').textContent = model.label;
  el('selected-contact').textContent = contact.label;
  el('photo-label').textContent = 'MODEL ' + model.id + ' · ' + model.profession;
  form.querySelectorAll('[data-mm-profession]').forEach(label => {
   label.hidden = label.dataset.mmProfession !== model.profession;
   label.querySelector('input').disabled = label.hidden;
   const item = data.models.find(item => item.id === label.querySelector('input').value);
   const photo = label.querySelector('img');
   if (!label.hidden && photo.getAttribute('src') !== item.images[state.contact]) photo.src=item.images[state.contact];
  });
  conditional('second', !editing && (Number.isInteger(model.names) ? model.names === 2 : state.model === '04'));
  el('name').disabled=editing;el('name').required=!editing;
  conditional('phone', !editing && (state.contact === 'telefon' || state.contact === 'telefon-eposta'));
  conditional('email', !editing && (state.contact === 'eposta' || state.contact === 'telefon-eposta'));
  const title = data.professions?.find(item => item.id === model.profession)?.title || (model.profession === 'SMMM' ? 'Serbest Muhasebeci Mali Müşavir' : 'Yeminli Mali Müşavir');
  if (data.family === 'lawyer') {
   const partnership = model.profession === 'ORTAKLIK';
   el('name-caption').textContent = partnership ? 'Ortaklığın tescilli adı' : 'Adınız ve soyadınız';
   el('name').name = partnership ? 'properties[Ortaklık Adı]' : 'properties[Ad Soyad]';
   el('name').placeholder = partnership ? 'Tabelaya yazılacak ortaklık adı' : 'Tabelaya yazılacak ad ve soyad';
   el('name').autocomplete = partnership ? 'organization' : 'name';
  }
  el('model-property').value = (editing ? 'Kişisel mesleki tasarım · ' : '') + model.label + ' (Model ' + model.id + ')';
  el('profession-property').value = title;
  el('contact-property').value = contact.label;
  el('size-property').value = checked('size');
  el('thickness-property').value = checked('thickness');
  el('mount-property').value = checked('mount');
  el('corner-property').value = checked('corner');
  el('summary').textContent = [editing?'Kendim tasarlıyorum · '+title:model.label, editing?'Mesleki tasarım aracı':contact.label, checked('size'), checked('thickness'), checked('mount'), checked('corner')].filter(Boolean).join(' · ');
  for(const name of ['size','thickness']) for(const input of radios(name)) {
   const option = variantForOptions(product,name==='size'?input.value:checked('size'),name==='thickness'?input.value:checked('thickness'),'Bantlı');
   input.closest('label').querySelector('[data-mm-option-price]').textContent=option?money(option.price)+' + KDV':'Şu anda sunulmuyor';
  }
  el('variant-id').value = variant?.id || '';
  el('add').disabled = state.submitting || !variant?.available || (editing && !window.RIDesigner?.ready());
  if (!variant) {
   el('error').textContent = 'Bu seçeneğin satış bilgisi henüz hazır değil. Lütfen başka bir model seçin veya bizimle iletişime geçin.';
   ['base-price','subtotal','vat','total'].forEach(id => {el(id).textContent='—';});
   return;
  }
  if (!variant.available) el('error').textContent = 'Bu üretim seçeneği şu anda satışa açık değil.';
  else if (!state.submitting) el('error').textContent = '';
  const base = variantFor(product, 'Bantlı');
  const fee = base ? Math.max(0,variant.price-base.price) : 0;
  const quantity = Math.min(99, Math.max(1, Math.floor(Number(el('quantity').value) || 1)));
  const subtotal = variant.price * quantity;
  const vat = Math.round(subtotal * Number(data.vatRate) / 100);
  el('base-price').textContent = money(base?.price ?? variant.price);
  el('mount-price-row').hidden = fee === 0;
  el('mount-price').textContent = money(fee);
  const screw = variantFor(product,'Vidalı');
  el('mount-option-price').textContent = screw && base ? '+'+money(screw.price-base.price) : 'Vidalı';
  el('mount-note').textContent = fee > 0 ? '4 krom başlı vida ve delik işlemi: ' + money(fee) + ' + KDV / tabela.' : 'Bantlı seçenekte tabela delik açılmadan hazırlanır.';
  el('subtotal').textContent = money(subtotal); el('vat').textContent = money(vat); el('total').textContent = money(subtotal+vat);
  const installment = form.querySelector('[data-installment-info]');
  if (installment) {
   installment.dataset.installmentGross = String(subtotal+vat);
   document.getElementById('installment-total-amount').textContent=money(Math.ceil((subtotal+vat)/3),true);
  }
  if (updateUrl && /^https?:$/.test(location.protocol)) {
   const url = new URL(location.href);
   url.searchParams.set('model', state.model); url.searchParams.set('iletisim', state.contact);
   url.searchParams.set('variant', String(variant.id)); url.searchParams.set('kose', checked('corner'));
   history.replaceState(null, '', url);
  }
 }
 radios('profession').forEach(input => input.addEventListener('change', () => {
  const model = data.models.find(model => model.profession === input.value);
  choose('model', model.id); update();
 }));
 ['model','contact','mount','size','thickness','corner'].forEach(name => radios(name).forEach(input => input.addEventListener('change', () => update())));
 form.querySelectorAll('[data-mm-quantity]').forEach(button=>button.addEventListener('click',()=>{
  el('quantity').value=String(Math.min(99,Math.max(1,(Number(el('quantity').value)||1)+Number(button.dataset.mmQuantity))));update(false);
 }));
 form.querySelector('[data-mm-size-help]')?.addEventListener('click',()=>{
  if(typeof modal==='function') modal('<div class="eyebrow">ÖLÇÜ REHBERİ</div><h2>Kapınızda ne kadar<br>yer ayırdınız?</h2><p>Önce kullanacağınız alanın genişliğini ve yüksekliğini ölçün. Aşağıdaki şekiller ölçü oranlarını karşılaştırır. 30 × 20 cm, yatay bir dikdörtgendir.</p><div class="size-guide"><div style="height:auto;aspect-ratio:3/2">30 × 20</div><div>40 × 30</div><div>60 × 40</div><div>90 × 60</div></div><p>Ölçüler cm cinsindedir. Özel ölçü ihtiyacınızı sipariş öncesi paylaşabilirsiniz.</p>',{label:'Ölçü rehberi'});
 });
 el('quantity').addEventListener('input', () => update(false));
 el('quantity').addEventListener('change', () => {el('quantity').value=String(Math.min(99,Math.max(1,Math.floor(Number(el('quantity').value)||1)))); update(false);});
 ['name','second-name','phone'].forEach(id => el(id).addEventListener('input', () => el(id).setCustomValidity('')));
 form.querySelector('[data-installment-info]')?.addEventListener('click', event => {
  if (typeof showInstallmentPlan === 'function') showInstallmentPlan(Number(event.currentTarget.dataset.installmentGross),'Seçtiğiniz ürünler üzerinden · KDV dâhil · Kargo hariç');
 });
 form.addEventListener('submit', async event => {
  event.preventDefault();
  if (state.submitting || !state.variant?.available) return;
  if(editorMode()&&!window.RIDesigner?.validate())return;
  ['name','second-name'].forEach(id => {
   const input=el(id); input.value=input.value.trim();
   if (!input.disabled) input.setCustomValidity(input.value ? '' : (data.family === 'lawyer' && checked('profession') === 'ORTAKLIK' ? 'Lütfen ortaklığın tabelaya yazılacak adını yazın.' : 'Lütfen tabelaya yazılacak ad ve soyadı yazın.'));
  });
  if (!el('phone').disabled) {
   const digits=el('phone').value.replace(/\D/g,'');
   el('phone').setCustomValidity(digits.length >= 7 && digits.length <= 15 ? '' : 'Lütfen alan koduyla birlikte geçerli bir telefon numarası yazın.');
  }
  if (!form.reportValidity()) return;
  state.submitting=true; el('add').disabled=true; el('add').textContent='Sepete ekleniyor…'; el('error').textContent='';
  try {
   const payload=new FormData(form);
   const response=await fetch(data.root+'cart/add.js',{method:'POST',body:payload,headers:{Accept:'application/json'}});
   const result=await response.json();
   if (!response.ok) throw new Error(result.description || 'Ürün eklenemedi. Lütfen tekrar deneyin.');
   location.assign(data.cartUrl);
  } catch(error) {
   state.submitting=false; el('add').disabled=false; el('add').textContent='Sepete ekle';
   if(addButtonIcon)el('add').append(addButtonIcon.cloneNode(true));
   el('error').textContent=error.message || 'Bağlantı kurulamadı. Lütfen tekrar deneyin.';
  }
 });
 form.addEventListener('ri:profession-design-state',()=>update(false));
 form.addEventListener('change',event=>{if(event.target.name==='designMode')update(false);});
 update(false);
})();
